<script>
import options from './PermissionBlock.options'
export default options
</script>

<template>
    <div class="nyk-permission-block">
        <!-- Screen reader live region for consent status announcements -->
        <div class="nyk-visually-hidden" aria-live="polite" aria-atomic="true">
            {{ statusMessage }}
        </div>

        <!-- Permission consent modal — accepted in cookies when functional consent exists, otherwise in session storage -->
        <Modal
            :open="modalOpen"
            :title="title"
            :close-aria-label="closeAriaLabel"
            :not-scrollable="true" 
            size="medium"
            body-display="flex"
            body-direction="column"
            @open="handleModalOpen"
            @close="handleModalClose"
        >
            <template #body>
                <!-- Language tab switcher — only visible when more than one language is configured -->
                <FilterTabs
                    v-if="tabs.length > 1"
                    :key="tabsKey"
                    :init-active-tab="currentLocale"
                    :tabs="tabs"
                    :callback="handleTabChange"
                    :can-show-dropdown="false"
                    class="nyk-permission-block__language-tabs"
                />

                <!-- Multilingual rich-text agreement body — aria-live announces language switch to screen readers -->
                <div
                    class="nyk-permission-block__agreement-text"
                    aria-live="polite"
                    v-html="agreementText">
                </div>
            </template>

            <template #footer>
                <!-- Consent checkboxes grouped for screen readers — pinned above the confirm button -->
                <div
                    class="nyk-permission-block__consents"
                    role="group"
                    :aria-label="consentsGroupLabel"
                >
                    <NykCheckbox
                        v-for="consent in currentConsents"
                        :key="consent.id"
                        :name="`permission-consent-${consent.id}`"
                        :label="consent.label"
                        :checked="consentValues[consent.id]"
                        @input="(val) => handleCheckboxInput(consent.id, val)"
                    />
                </div>

                <div class="nyk-permission-block__confirm-button">
                    <NykButton
                        variant="filled-primary"
                        :disabled="!allConsentsChecked"
                        :aria-disabled="!allConsentsChecked ? 'true' : undefined"
                        @click="handleAgree"
                    >
                        {{ agreeButtonLabel }}
                    </NykButton>
                </div>
            </template>
        </Modal>
    </div>
</template>
